export const registrationGoals = [
    { value: 'exam', label: 'Exam Preparation' },
    { value: 'improve', label: 'Improve overall goal' },
    { value: 'weakness', label: 'Strengthen weak areas in a subject' },
    { value: 'confidence', label: 'Build confidence in learning' }
];

export const grades = [
    // { name: 'Grade 01', code: 'grade_01' },
    // { name: 'Grade 02', code: 'grade_02' },
    // { name: 'Grade 03', code: 'grade_03' },
    // { name: 'Grade 04', code: 'grade_04' },
    { name: 'Grade 05', code: 'grade_05' },
    { name: 'Grade 06', code: 'grade_06' },
    { name: 'Grade 07', code: 'grade_07' },
    { name: 'Grade 08', code: 'grade_08' },
    { name: 'Grade 09', code: 'grade_09' },
    { name: 'Grade 10', code: 'grade_10' },
    { name: 'Grade 11 / O-Level (Local)', code: 'o_level_local' },
    { name: 'London O-Levels', code: 'london_o_levels' },
    { name: 'A-Level (Local)', code: 'a_level_local' },
    { name: 'London A-Level – Edexcel', code: 'london_a_level_edexcel' },
    { name: 'London A-Level – Cambridge', code: 'london_a_level_cambridge' },
];

export const examMediums = [
    { name: 'Local', code: 'local' },
    { name: 'Edexcel', code: 'edexcel' },
    { name: 'Cambridge', code: 'cambridge' }
];

export const mediumOptions = [
    { value: 'Sinhala', label: 'Sinhala' },
    { value: 'English', label: 'English' },
    { value: 'Tamil', label: 'Tamil' },
];
export const termList = [
  { name: 'Term 1', code: 'term_1' },
  { name: 'Term 2', code: 'term_2' },
  { name: 'Term 3', code: 'term_3' },

  { name: 'Local O/L', code: 'local_ol' },
  { name: 'Local A/L', code: 'local_al' },

  { name: 'London O/L', code: 'london_ol' },
  { name: 'London A/L (Edexcel)', code: 'london_al_edexcel' },
  { name: 'London A/L (Cambridge)', code: 'london_al_cambridge' },
  
//   { name: 'Not Term Specific', code: 'not_term_specific' },
];

export const subjects = [
    // --- Core Mandatory Subjects (Grades 1-11) ---
    { name: 'Mathematics', code: 'maths' },
    { name: 'Science', code: 'science' },
    { name: 'History', code: 'history' },
    { name: 'English Language', code: 'english_language' },
    { name: 'First Language (Sinhala/Tamil)', code: 'first_language' },
    { name: 'Religion (Buddhism/Hinduism/Islam/Christianity/Catholicism)', code: 'religion' },
    { name: 'Health and Physical Education', code: 'health_physical_education' },
    { name: 'Life Competencies and Civic Education (or Civics)', code: 'civic_education' },
    { name: 'Practical and Technical Skills', code: 'technical_skills' }, // Junior Secondary (G6-9)

    // --- Social Sciences & Humanities (O/L Electives & A/L Arts/Commerce) ---
    { name: 'Geography', code: 'geography' },
    { name: 'Business & Accounting Studies', code: 'business_accounting_studies' },
    { name: 'Entrepreneurship Studies', code: 'entrepreneurship_studies' },
    { name: 'Economics', code: 'economics' },
    { name: 'Home Economics', code: 'home_economics' },
    { name: 'Logic and Scientific Method', code: 'logic_scientific_method' },
    { name: 'Political Science / Elements of Political Science', code: 'political_science' },
    { name: 'Communication & Media Studies', code: 'media_studies' },
    { name: 'Buddhist Civilization', code: 'buddhist_civilization' },
    { name: 'Hindu Civilization', code: 'hindu_civilization' },
    { name: 'Islam Civilization', code: 'islam_civilization' },
    { name: 'Christian Civilization', code: 'christian_civilization' },
    { name: 'Greek and Roman Civilization', code: 'greek_roman_civilization' },

    // --- Languages & Literature (O/L & A/L) ---
    { name: 'Second National Language (Sinhala/Tamil)', code: 'second_language' },
    { name: 'Appreciation of Sinhala Literary Texts (Sinhala Literature)', code: 'sinhala_literature' },
    { name: 'Appreciation of Tamil Literary Texts (Tamil Literature)', code: 'tamil_literature' },
    { name: 'Appreciation of English Literary Texts (English Literature)', code: 'english_literature' },
    { name: 'Appreciation of Arabic Literary Texts (Arabic Literature)', code: 'arabic_literature' },
    { name: 'Pali', code: 'pali' },
    { name: 'Sanskrit', code: 'sanskrit' },
    { name: 'French Language', code: 'french' },
    { name: 'German Language', code: 'german' },
    { name: 'Hindi Language', code: 'hindi' },
    { name: 'Japanese Language', code: 'japanese' },
    { name: 'Chinese Language', code: 'chinese' },
    // Other A/L Languages: Arabic, Korean, Malay, Persian, Russian, Urdu, Greek, Latin

    // --- Aesthetic Subjects (O/L & A/L Arts) ---
    { name: 'Art / Visual Arts', code: 'art' },
    { name: 'Oriental Music', code: 'oriental_music' },
    { name: 'Western Music', code: 'western_music' },
    { name: 'Carnatic Music', code: 'carnatic_music' },
    { name: 'Oriental Dancing', code: 'oriental_dancing' },
    { name: 'Bharata Dancing', code: 'bharata_dancing' },
    { name: 'Drama and Theatre (Sinhala/Tamil/English)', code: 'drama_theatre' },

    // --- Technology & Vocational (O/L & A/L Technology) ---
    { name: 'Information & Communication Technology (ICT)', code: 'ict' },
    { name: 'Agriculture & Food Technology', code: 'agriculture_food_tech' },
    { name: 'Aquatic Bioresources Technology', code: 'aquatic_bioresources_tech' },
    { name: 'Arts & Crafts', code: 'arts_crafts' },
    { name: 'Design & Construction Technology', code: 'design_construction_tech' },
    { name: 'Design & Mechanical Technology', code: 'design_mechanical_tech' },
    { name: 'Design, Electrical & Electronic Technology', code: 'design_electrical_electronic_tech' },

    // --- Advanced Level (A/L - Grades 12-13) Stream Specific Subjects ---
    // Science/Maths Stream
    { name: 'Physics', code: 'physics' },
    { name: 'Chemistry', code: 'chemistry' },
    { name: 'Biology', code: 'biology' },
    { name: 'Combined Mathematics', code: 'combined_mathematics' },
    { name: 'Agricultural Science', code: 'agricultural_science_al' },

    // Commerce Stream
    { name: 'Accounting', code: 'accounting' },
    { name: 'Business Studies', code: 'business_studies' },
    { name: 'Business Statistics', code: 'business_statistics' },

    // Technology Stream
    { name: 'Engineering Technology', code: 'engineering_technology' },
    { name: 'Bio-system Technology', code: 'bio_system_technology' },
    { name: 'Science for Technology', code: 'science_for_technology' },

    // Compulsory A/L Components
    { name: 'General English', code: 'general_english' },
    { name: 'Common General Test', code: 'common_general_test' },
];

export const learningOptions = [
    { value: 'Online', label: 'Online' },
    // { value: 'In-person', label: 'In-person' },

];

export const timeOptions = [
    { value: 'Morning', label: 'Morning' },
    { value: 'Afternoon', label: 'Afternoon' },
    { value: 'Evening', label: 'Evening' },
    { value: 'Weekends', label: 'Weekends' }
];

export const gender = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
];

export const occupation = [
    { value: "Undergraduate Tutor", key: "undergraduate_tutor" },
    { value: "Graduate Tutor", key: "graduate_tutor" },
    { value: "Experienced Tutor (2+ years)", key: "experienced_tutor" },
    { value: "Professional Tutor (5+ years)", key: "professional_tutor" },
    { value: "Subject Specialist", key: "subject_specialist" },
];

export const classType = [
    { value: "online", key: "online" },
    /** Temporarily disabled until the system supports all class types */
    // { value: "physical", key: "physical" },
    // { value: "both", key: "both" }
];

export const locations = [
    // { value: "Tutor’s place", key: "tutors_place" },
    // { value: "Student’s place", key: "students_place" },
    // { value: "Both", key: "both" },
];

export const languages = [
    { value: "English", key: "english" },
    { value: "Sinhala", key: "sinhala" },
    { value: "Tamil", key: "tamil" },
];

export const availabilityOptions = [
    { value: "Morning", key: "morning" },
    { value: "Afternoon", key: "afternoon" },
    { value: "Evening", key: "evening" },
    { value: "Weekends", key: "weekends" }
];

export const verificationCallEmailTemplate = (studentName, tutorName)=>{
    return `
    <p>Dear&nbsp;${studentName},</p><p></p>
    <p>Thank&nbsp;you&nbsp;for&nbsp;your&nbsp;interest&nbsp;in&nbsp;the&nbsp;tutoring&nbsp;classes!&nbsp;
    I’m&nbsp;excited&nbsp;to&nbsp;start&nbsp;planning&nbsp;your&nbsp;sessions.</p><p></p>
    <p>The&nbsp;final&nbsp;step&nbsp;before&nbsp;I&nbsp;create&nbsp;and&nbsp;finalize&nbsp;your&nbsp;personalized&nbsp;class&nbsp;schedule&nbsp;is&nbsp;a&nbsp;brief&nbsp;
    <strong>Verification&nbsp;Call</strong>.&nbsp;</p>
    <p>This&nbsp;is&nbsp;a&nbsp;<strong>crucial</strong>&nbsp;(10-15&nbsp;minute)&nbsp;discussion&nbsp;where&nbsp;we&nbsp;will:</p><p></p>
    <ul><li>Confirm&nbsp;your&nbsp;best&nbsp;availability.</li><li>Agree&nbsp;on&nbsp;the&nbsp;desired&nbsp;session&nbsp;frequency&nbsp;and&nbsp;duration.</li>
    <li>Ensure&nbsp;the&nbsp;overall&nbsp;class&nbsp;timeline&nbsp;works&nbsp;perfectly&nbsp;for&nbsp;both&nbsp;of&nbsp;us.</li></ul><p></p>
    <p>I&nbsp;have&nbsp;scheduled&nbsp;this&nbsp;essential&nbsp;call&nbsp;for&nbsp;the&nbsp;following&nbsp;time.</p><p>---</p>
    <p><strong><u>Confirmed&nbsp;Call&nbsp;Details:</u></strong></p><p></p><p>
    <strong>Date:</strong>&nbsp;[CALL&nbsp;DATE,&nbsp;e.g.,&nbsp;Monday,&nbsp;October&nbsp;28th]</p><p>
    <strong>Time:</strong>&nbsp;[CALL&nbsp;TIME,&nbsp;e.g.,&nbsp;2:00&nbsp;PM]&nbsp;[TIME&nbsp;ZONE,&nbsp;e.g.,&nbsp;EST/IST]</p><p></p>
    <p><strong><u>How&nbsp;to&nbsp;Join:</u></strong></p>
    <p>[MEETING&nbsp;PLATFORM,&nbsp;e.g.,&nbsp;Google&nbsp;Meet&nbsp;/&nbsp;Zoom&nbsp;/&nbsp;Phone&nbsp;Call]&nbsp;Link:&nbsp;**[MEETING&nbsp;LINK&nbsp;or&nbsp;PHONE&nbsp;NUMBER]**</p>
    <p>---</p><p></p><p>If,&nbsp;for&nbsp;any&nbsp;reason,&nbsp;this&nbsp;scheduled&nbsp;time&nbsp;does&nbsp;not&nbsp;work&nbsp;for&nbsp;you,&nbsp;please&nbsp;contact&nbsp;me&nbsp;
    <strong>immediately</strong>&nbsp;so&nbsp;we&nbsp;can&nbsp;find&nbsp;an&nbsp;alternative&nbsp;slot.</p>
    <p>I&nbsp;look&nbsp;forward&nbsp;to&nbsp;speaking&nbsp;with&nbsp;you&nbsp;and&nbsp;getting&nbsp;your&nbsp;classes&nbsp;on&nbsp;the&nbsp;calendar!</p><p></p>
    <p>Best&nbsp;regards,</p><p>${tutorName}</p><p></p>
`
}

import { ref } from "vue";
import { getGrades } from "@/api/grade";

export const gradeOptions = ref([]);
export const isLoadingGrades = ref(false);

/**
 * Fetches grades and their embedded subjects from the backend
 */
export const fetchGradeOptions = async () => {
    if (isLoadingGrades.value) return;

    isLoadingGrades.value = true;
    try {
        // Fetching with a high limit to ensure all grades are pulled for the dropdowns
        const response = await getGrades({ limit: 100 });
        
        const gradesData = response?.data?.grades || response?.grades || response?.data?.data?.grades || [];

        gradeOptions.value = gradesData.map(grade => ({
            ...grade,
            name: grade.name,
            subjects: grade.subjects || []
        }));
    } catch (error) {
        console.error("Failed to fetch academic grades and subjects:", error);
    } finally {
        isLoadingGrades.value = false;
    }
};

// Automatically fetch grades when this file is imported
fetchGradeOptions();